<template>
  <div>
    <tab-list :tabList="tableData" :columns="columns">
     </tab-list>
    <tab-list-checkbox  :tabList="tableData" :columns="columns"></tab-list-checkbox>
    
    <vxe-tab></vxe-tab>

  </div>
</template>

<script>
  import tabList from 'components/table/listRadio.vue'
  import tabListCheckbox from 'components/table/listCheckbox.vue';
  import vxeTab from 'components/table/vxeTab.vue';
  export default{
      components:{
        tabList,
        tabListCheckbox,
        vxeTab
      },
      data(){
        return{
          columns:[
            {"field":"data","title":"日期","width":150},
            {"field":"name","title":"姓名","width":150},
            {"field":"province","title":"省市","width":150},
            {"field":"city","title":"城市","width":150},
            {"field":"address","title":"地址"},
            {"field":"zip","title":"邮编","width":150}
          ],
          tableData: [{
                    date: '2016-05-03',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                  }, {
                    date: '2016-05-02',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                  }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                  }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                  }, {
                    date: '2016-05-08',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                  }, {
                    date: '2016-05-06',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                  }, {
                    date: '2016-05-07',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                  }]
        }
      }
  }
</script>

<style>
</style>
